module.exports = __webpack_public_path__ + "static/media/Cuatro.1e472200.png";